import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
import { keyBy, clone, find } from 'lodash';
import {
  fetchUserData,
} from './userReducer';
import axios from 'axios';
import * as rax from 'retry-axios';
import { axiosTransform } from '../configureStore';
import { checkAndUpdateScheduleLink } from 'containers/App/screens/Tube/screens/Index/reducers/linkReducer';
const {
  API_SERVER,
  NEWTUBE_API_SERVER,
} = url;
import { setCookie } from 'utils/cookie';

// PreferenceSettings 的 settingKey 常量
export const PREFERENCE_SETTING_KEYS = {
  USE_NEW_UI: 'UseNewUI',
};

const INIT = 'tube/app/application/INIT';
const INIT_SUCCESS = 'tube/app/application/INIT_SUCCESS';
const INIT_FAIL = 'tube/app/application/INIT_FAIL';
const FETCH_FIELD_SETTINGS_REQUEST = 'tube/app/application/FETCH_FIELD_SETTINGS_REQUEST';
const FETCH_FIELD_SETTINGS_SUCCESS = 'tube/app/application/FETCH_FIELD_SETTINGS_SUCCESS';
const FETCH_LOGIN_STATUS_SUCCESS = 'tube/app/application/FETCH_LOGIN_STATUS_SUCCESS';
const SET_PROGRESS = 'tube/app/application/SET_PROGRESS';
const FETCH_COMPANY_SETTINGS_REQUEST = 'tube/app/application/FETCH_COMPANY_SETTING_REQUEST';
const FETCH_COMPANY_SETTINGS_SUCCESS = 'tube/app/application/FETCH_COMPANY_SETTING_SUCCESS';
const FETCH_SITE_SETTINGS_REQUEST = 'tube/app/application/FETCH_SITE_SETTING_REQUEST';
const FETCH_SITE_SETTINGS_SUCCESS = 'tube/app/application/FETCH_SITE_SETTING_SUCCESS';
const UPDATE_SITE_SETTINGS = 'tube/app/application/UPDATE_SITE_SETTINGS';
const UPDATE_SITE_SETTINGS_SUCCESS = 'tube/app/application/UPDATE_SITE_SETTINGS_SUCCESS';
const SET_MESSAGE = 'tube/app/application/SET_MESSAGE';
const RESET_MESSAGE = 'tube/app/application/RESET_MESSAGE';

const FETCH_LOCALE_FILE_REQUEST = 'tube/app/application/FETCH_LOCALE_FILE_REQUEST';
const FETCH_LOCALE_FILE_SUCCESS = 'tube/app/application/FETCH_LOCALE_FILE_SUCCESS';
const FETCH_LOCALE_FILE_FAIL = 'tube/app/application/FETCH_LOCALE_FILE_FAIL';
const FETCH_LANGUAGE_REQUEST = 'tube/app/application/FETCH_LANGUAGE_REQUEST';
const FETCH_LANGUAGE_SUCCESS = 'tube/app/application/FETCH_LANGUAGE_SUCCESS';
const FETCH_LANGUAGE_FAIL = 'tube/app/application/FETCH_LANGUAGE_FAIL';
const FETCH_ANONYMOUS_LANGUAGE_REQUEST = 'tube/app/application/FETCH_ANONYMOUS_LANGUAGE_REQUEST';
const FETCH_ANONYMOUS_LANGUAGE_SUCCESS = 'tube/app/application/FETCH_ANONYMOUS_LANGUAGE_SUCCESS';
const FETCH_ANONYMOUS_LANGUAGE_FAIL = 'tube/app/application/FETCH_ANONYMOUS_LANGUAGE_FAIL';

const FETCH_FUNCTION_SETTING = 'tube/app/application/FETCH_FUNCTION_SETTING';
const FETCH_FUNCTION_SETTING_REQUEST = 'tube/app/application/FETCH_FUNCTION_SETTING_REQUEST';
const FETCH_FUNCTION_SETTING_SUCCESS = 'tube/app/application/FETCH_FUNCTION_SETTING_SUCCESS';
const UPDATE_FUNCTION_SETTING = 'tube/company-space/function-setting/UPDATE_FUNCTION_SETTING';
const UPDATE_FUNCTION_SETTING_REQUEST = 'tube/company-space/function-setting/UPDATE_FUNCTION_SETTING_REQUEST';
const UPDATE_FUNCTION_SETTING_SUCCESS = 'tube/company-space/function-setting/UPDATE_FUNCTION_SETTING_SUCCESS';
const FETCH_PUBLISHED_FORM_COUNT = 'tube/app/application/FETCH_PUBLISHED_FORM_COUNT';
const FETCH_PUBLISHED_FORM_COUNT_REQUEST = 'tube/app/application/FETCH_PUBLISHED_FORM_COUNT_REQUEST';
const FETCH_PUBLISHED_FORM_COUNT_SUCCESS = 'tube/app/application/FETCH_PUBLISHED_FORM_COUNT_SUCCESS';
const FETCH_FUNCTIONS_BY_COMPANY = 'tube/app/application/FETCH_FUNCTIONS_BY_COMPANY';
const FETCH_FUNCTIONS_BY_COMPANY_REQUEST = 'tube/app/application/FETCH_FUNCTIONS_BY_COMPANY_REQUEST';
const FETCH_FUNCTIONS_BY_COMPANY_SUCCESS = 'tube/app/application/FETCH_FUNCTIONS_BY_COMPANY_SUCCESS';
const FETCH_FUNCTIONS_BY_COMPANY_FAIL = 'tube/app/application/FETCH_FUNCTIONS_BY_COMPANY_FAIL';

const FETCH_PREFERENCE_SETTINGS = 'tube/app/application/FETCH_PREFERENCE_SETTINGS';
const FETCH_PREFERENCE_SETTINGS_REQUEST = 'tube/app/application/FETCH_PREFERENCE_SETTINGS_REQUEST';
const FETCH_PREFERENCE_SETTINGS_SUCCESS = 'tube/app/application/FETCH_PREFERENCE_SETTINGS_SUCCESS';
const FETCH_PREFERENCE_SETTINGS_FAIL = 'tube/app/application/FETCH_PREFERENCE_SETTINGS_FAIL';

const SET_OTHER_ACCOUNT_LOGIN_STATUS = 'tube/app/application/SET_OTHER_ACCOUNT_LOGIN_STATUS';
const TOGGLE_ONBOARDINGPROCESS_STATUS = 'tube/app/application/TOGGLE_ONBOARDINGPROCESS_STATUS';
const client = axios.create({
  timeout: 10000,
  transformRequest: axiosTransform.request,
  transformResponse: axiosTransform.response,
});

client.defaults.raxConfig = {
  instance: client,
  retry: 99,
  noResponseRetries: 99,
};

rax.attach(client);

const initialState = {
  isLoaded: false,
  moduleType: undefined,
  locale: 'zh-tw',
  accessToken: undefined,
  isLoggedIn: false,
  progresses: [],
  locales: [],
  localeMessage: undefined,
  theme: {
    footerColor: '#000',
    footerFontColor: '#ccc',
    headerColor: '#000',
    headerFontColor: '#fff',
    menuFontColor: '#ccc',
    menuHoverFontColor: '#fff',
  },
  message: {
    content: '',
    title: '',
    onConfirm: undefined,
    onCancel: undefined,
  },
  imported: undefined,
  isPreviewMode: false,
  isOtherAccountLoggedIn: false,
  isShowOnboardingProcess: false,
  companyName: '',
  loginLogoUrl: '',
  companyLogoUrl: '',
  carouselSeconds: 10,
  functionSetting: {
    datas: [],
    isLoading: false,
  },
  publishedFormCount: 0,
  functionsByCompany: {
    data: [],
    isLoading: false,
  },
  preferenceSettings: {
    isLoading: false,
    isLoaded: false,
    data: [],
  },
};


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case INIT_SUCCESS:
      return Object.assign({}, state, {
        isLoaded: true,
      });
    case FETCH_LOGIN_STATUS_SUCCESS:
      return Object.assign({}, state, { isLoggedIn: true });
    case FETCH_FIELD_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        fieldSettings: keyBy(action.response, (o) => {
          return '_' + o.fieldCode;
        }),
      });
    case SET_PROGRESS:
      const progresses = clone(state.progresses ? state.progresses : []);
      let isExist = false;
      for (let idx = progresses.length - 1; idx >= 0; idx--) {
        const progress = progresses[idx];
        if (progress.key === action.key) {
          isExist = true;
          if (action.progress === -1) {
            progresses.splice(idx, 1);
          } else {
            progress.progress = action.progress;
          }
        }
      }

      if (!isExist) {
        progresses.push({
          key: action.key,
          progress: action.progress,
          color: action.color,
        });
      }

      return Object.assign({}, state, { progresses });
    case FETCH_COMPANY_SETTINGS_SUCCESS:
      const { importStatus } = action.response.data;
      return Object.assign({}, state, {
        // theme: theme ? theme : state.theme,
        imported: importStatus === 'Initial' ? false : true,
      });
    case FETCH_SITE_SETTINGS_SUCCESS:
      const {
        companyName,
        loginLogoUrl,
        companyLogoUrl,
        carouselSeconds,
      } = action.response.data;
      return Object.assign({}, state, {
        companyName,
        loginLogoUrl,
        companyLogoUrl,
        carouselSeconds,
      });
    case UPDATE_SITE_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        companyLogoUrl: action.payload.data.data.companyLogo,
      });
    case SET_MESSAGE:
      {
        const message = Object.assign({}, state.message, {
          content: action.content,
          title: action.title,
          onConfirm: action.onConfirm,
          onCancel: action.onCancel,
        });
        return Object.assign({}, state, {
          message,
        });
      }
    case RESET_MESSAGE:
      {
        const message = Object.assign({}, state.message, {
          content: '',
          title: '',
          onConfirm: undefined,
          onCancel: undefined,
        });
        return Object.assign({}, state, {
          message,
        });
      }
    case FETCH_LOCALE_FILE_SUCCESS:
      axios.defaults.headers.common['Accept-Language'] = action.locale;
      return Object.assign({}, state, {
        localeMessage: action.response,
        locale: action.locale,
        headers: {
          'Accept-Language': action.locale,
        },
      });
    case FETCH_LOCALE_FILE_FAIL:
      return Object.assign({}, state, {
        localeMessage: {},
      });
    case FETCH_LANGUAGE_SUCCESS:
      {
        let locale = state.locale;
        const locales = action.response.data.availableLanguages;


        if (find(locales, { 'code': locale }) === undefined) {
          locale = action.response.data.defaultLanguage;
        }

        return Object.assign({}, state, {
          locale,
          locales,
        });
      }
    case SET_OTHER_ACCOUNT_LOGIN_STATUS:
      return Object.assign({}, state, {
        isOtherAccountLoggedIn: true,
      });
    case FETCH_FUNCTION_SETTING_REQUEST:
      return Object.assign({}, state, {
        functionSetting: Object.assign({}, state.functionSetting, { isLoading: true }),
      });
    case FETCH_FUNCTION_SETTING_SUCCESS:
      {
        const newFunctionSetting = Object.assign({}, state.functionSetting, {
          datas: action.payload.data.data.functionDisableList,
          isLoading: false,
        });
        return Object.assign({}, state, { functionSetting: newFunctionSetting });
      }
    case FETCH_FUNCTIONS_BY_COMPANY_REQUEST:
      return Object.assign({}, state, {
        functionsByCompany: Object.assign({}, state.functionsByCompany, { isLoading: true }),
      });
    case FETCH_FUNCTIONS_BY_COMPANY_FAIL:
      return Object.assign({}, state, {
        functionsByCompany: Object.assign({}, state.functionsByCompany, { isLoading: false }),
      });
    case FETCH_FUNCTIONS_BY_COMPANY_SUCCESS:
      {
        return Object.assign({}, state, { functionsByCompany: action.payload.data });
      }
    case UPDATE_FUNCTION_SETTING_REQUEST:
      {
        return Object.assign({}, state, {
          functionSetting: Object.assign({}, state.functionSetting, { isLoading: true }),
        });
      }
    case UPDATE_FUNCTION_SETTING_SUCCESS:
      {
        const newFunctionSetting = Object.assign({}, state.functionSetting, {
          datas: action.payload.data.data.functionDisableList,
          isLoading: false,
        });
        return Object.assign({}, state, { functionSetting: newFunctionSetting });
      }
    case FETCH_PUBLISHED_FORM_COUNT_REQUEST:
      {
        return Object.assign({}, state, { publishedFormCount: 0 });
      }
    case FETCH_PUBLISHED_FORM_COUNT_SUCCESS:
      {
        return Object.assign({}, state, { publishedFormCount: action.payload.data });
      }
    case FETCH_PREFERENCE_SETTINGS_REQUEST:
      return Object.assign({}, state, {
        preferenceSettings: Object.assign({}, state.preferenceSettings, { isLoading: true }),
      });
    case FETCH_PREFERENCE_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        preferenceSettings: {
          isLoading: false,
          isLoaded: true,
          data: action.payload.data,
        },
      });
    case FETCH_PREFERENCE_SETTINGS_FAIL:
      return Object.assign({}, state, {
        preferenceSettings: Object.assign({}, state.preferenceSettings, {
          isLoading: false,
          isLoaded: true,
        }),
      });
    case TOGGLE_ONBOARDINGPROCESS_STATUS:
      const isShowOnboardingProcess = action.enable;
      localStorage.setItem('isShowOnboardingProcess', isShowOnboardingProcess);
      return Object.assign({}, state, {
        isShowOnboardingProcess,
      });
    default:
      return state;
  }
}

function clearHnCache() {
  for (const key in sessionStorage) {
    if (key.indexOf('HnCache') > -1) {
      sessionStorage.removeItem(key);
    }
  }
}

export function fetchFieldSettings(dispatch, language) {
  if (sessionStorage.HnCache_FieldSettings_zh_tw !== undefined) {
    const fields = JSON.parse(sessionStorage.HnCache_FieldSettings_zh_tw);
    const fieldsJson = Object.values(fields);
    dispatch({
      response: fieldsJson,
      type: FETCH_FIELD_SETTINGS_SUCCESS,
    });

    return () => {
      return Promise.resolve(fieldsJson);
    };
  }

  return {
    [CALL_API]: {
      url: API_SERVER + 'signer/BASE_Field/GetAll',
      method: 'GET',
      types: [FETCH_FIELD_SETTINGS_REQUEST, FETCH_FIELD_SETTINGS_SUCCESS, INIT_FAIL],
      params: {
        language: language ? language : 'zh-tw',
      },
      onSuccess: (json) => {
        const fields = {};
        json.forEach((field) => {
          fields[field.fieldCode] = field;
        });
        sessionStorage.HnCache_FieldSettings_zh_tw = JSON.stringify(fields);
        const now = new Date();
        const needSetExiredOn = (!sessionStorage.HnCache_ExpiredOn || now > new Date(JSON.parse(sessionStorage.HnCache_ExpiredOn)));
        if (needSetExiredOn) {
          clearHnCache();
          const noon = now.setHours(13, 0, 0, 0);
          const midnight = now.setHours(25, 0, 0, 0);
          sessionStorage.HnCache_ExpiredOn = now > noon ? midnight : noon;
        }
      },
    },
  };
}

export function setProgress(key, progress, color) {
  return (dispatch) => {
    if (progress >= 100) {
      setTimeout(() => {
        dispatch({
          type: SET_PROGRESS,
          key,
          progress: -1,
        });
      }, 500);
    }
    dispatch({
      type: SET_PROGRESS,
      key,
      progress,
      color,
    });
  };
}

export function fetchCompanySettings(dispatch) {
  dispatch({
    type: FETCH_COMPANY_SETTINGS_REQUEST,
  });
  return client(`${NEWTUBE_API_SERVER}companysettings`, {
    raxConfig: {
      retry: 99,
      noResponseRetries: 99,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_COMPANY_SETTINGS_SUCCESS,
      response: {
        data: response.data.data,
      },
    });
  });
}

export function fetchSiteSettings(dispatch) {
  dispatch({
    type: FETCH_SITE_SETTINGS_REQUEST,
  });
  return client(`${NEWTUBE_API_SERVER}backoffice`, {
    raxConfig: {
      retry: 99,
      noResponseRetries: 99,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_SITE_SETTINGS_SUCCESS,
      response: {
        data: response.data.data,
      },
    });
  });
}

export function updateSiteSetting(data) {
  const formData = new FormData();

  Object.keys(data).map((key) => {
    formData.append(key, data[key] === null ? '' : data[key]);
  });
  return {
    type: UPDATE_SITE_SETTINGS,
    payload: axios.post(
      `${NEWTUBE_API_SERVER}backoffice`,
      formData,
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      }
    ),
    data,
  };
}

export function getLoginStatus() {
  return (dispatch) => dispatch({
    type: FETCH_LOGIN_STATUS_SUCCESS,
  });
}

export function loadLocalFile(dispatch, moduleType, locale) {
  if (moduleType !== undefined && locale !== undefined) {
    dispatch({
      type: FETCH_LOCALE_FILE_REQUEST,
    });
    return client(`${location.origin}/assets/dist/foundation/${moduleType}.${locale}.json`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
      },
      raxConfig: {
        retry: 99,
        noResponseRetries: 99,
      },
      transformResponse: (resp) => resp,
    }).then((response) => {
      dispatch({
        type: FETCH_LOCALE_FILE_SUCCESS,
        response: response.data,
        locale,
      });
    }, () => dispatch({ type: FETCH_LOCALE_FILE_FAIL }));
  }

  return { type: 'NOTHING_TODO' };
}

export function switchLocale(locale) {
  return (dispatch, getState) => {
    const {
      app: {
        application: {
          moduleType,
          isLoggedIn,
        },
      },
    } = getState();
    localStorage.setItem('locale', locale);
    sessionStorage.locale = locale;
    document.cookie = `XElocale=${locale}`;
    setCookie('locale', locale, undefined, '.mayohr.com', '/'); // 另開新站也需要接得到語系
    loadLocalFile(dispatch, moduleType, locale).then(() => {
      if (isLoggedIn) {
        dispatch(fetchUserData());
      }
    });
  };
}

export function fetchLanguage(dispatch, getState) {
  dispatch({
    type: FETCH_LANGUAGE_REQUEST,
  });
  return client(`${NEWTUBE_API_SERVER}DefaultLanguage/GetCompany`, {
    raxConfig: {
      retry: 99,
      noResponseRetries: 99,
    },
  }).then((response) => {
    const { app: { application: { locale, moduleType } } } = getState();
    loadLocalFile(dispatch, moduleType, locale);
    dispatch({
      type: FETCH_LANGUAGE_SUCCESS,
      response: {
        data: response.data.data,
      },
    });
  }, () => dispatch({ type: FETCH_LANGUAGE_FAIL }));
}
export function fetchAnonymousLanguage(dispatch, getState) {
  dispatch({
    type: FETCH_ANONYMOUS_LANGUAGE_REQUEST,
  });
  return client(`${NEWTUBE_API_SERVER}anonymous/DefaultLanguage/GetAll`, {
    raxConfig: {
      retry: 99,
      noResponseRetries: 99,
    },
  }).then((response) => {
    const { app: { application: { locale, moduleType } } } = getState();

    loadLocalFile(dispatch, moduleType, locale);
    dispatch({
      type: FETCH_ANONYMOUS_LANGUAGE_SUCCESS,
      response: {
        data: response.data.data,
      },
    });
  }, () => dispatch({ type: FETCH_ANONYMOUS_LANGUAGE_FAIL }));
}

export function fetchFunctionSetting() {
  return {
    type: FETCH_FUNCTION_SETTING,
    payload: axios.get(`${url.WEBBFF_API_SERVER}FunctionDisableList`),
  };
}

export function updateFunctionSetting(data) {
  return {
    type: UPDATE_FUNCTION_SETTING,
    payload: axios.put(`${url.WEBBFF_API_SERVER}FunctionDisableList`, data),
  };
}

// 取得終端管理者可以開關的功能，對應營運後台的API
export function fetchFunctionsByCompany() {
  return {
    type: FETCH_FUNCTIONS_BY_COMPANY,
    payload: axios.get(`${url.WEBBFF_API_SERVER}company/getfunctions`),
  };
}

export function fetchPublishedFormCount() {
  return {
    type: FETCH_PUBLISHED_FORM_COUNT,
    payload: axios.get(`${url.WEBBFF_API_SERVER}Form/Company/Summary/PublishedFormCount`),
  };
}

// 取得使用者偏好設定
export function fetchPreferenceSettings() {
  return {
    type: FETCH_PREFERENCE_SETTINGS,
    payload: axios.get(`${url.PLATFORM_BFF_API_SERVER}v2/employees/preferenceSettings?moduleCode=TA`),
  };
}

// Helper function: 取得特定偏好設定值
export function getPreferenceSettingValue(preferenceSettings, settingKey) {
  if (!preferenceSettings || !preferenceSettings.data || !Array.isArray(preferenceSettings.data)) {
    return null;
  }
  const setting = preferenceSettings.data.find(s => s.settingKey === settingKey);
  return setting ? setting.value : null;
}

export function init() {
  return (dispatch, getState) => {
    const { app: { application: { locale, moduleType, isLoggedIn } } } = getState();

    const actions = [
      {
        dispatchMethod: loadLocalFile.bind(null, dispatch, moduleType, locale),
      },
    ];
    if (isLoggedIn) {
      actions.push(
        {
          dispatchMethod: fetchLanguage.bind(null, dispatch, getState),
        },
        {
          dispatchMethod: fetchCompanySettings.bind(null, dispatch),
        },
        {
          dispatchMethod: fetchSiteSettings.bind(null, dispatch),
        },
        {
          dispatchMethod: () => dispatch(fetchFunctionSetting()),
        },
        {
          dispatchMethod: () => dispatch(fetchPreferenceSettings()),
        }
      );
    } else {
      actions.push(
        {
          dispatchMethod: fetchAnonymousLanguage.bind(null, dispatch, getState),
        }
      );
    }

    const progressKey = 'INIT_APPLICATION_INFO';

    const progressStep = 80 / actions.length;
    let initedActionCount = 0;

    dispatch({
      type: INIT,
    });

    dispatch(setProgress(progressKey, 20, '#3072AB'));

    actions.forEach((action) => {
      action.dispatchMethod().then(() => {
        initedActionCount += 1;
        if (initedActionCount === actions.length) {
          dispatch({
            type: INIT_SUCCESS,
          });
          dispatch(setProgress(progressKey, 100));
          // 所有初始化完成后检查并更新 schedule link
          dispatch(checkAndUpdateScheduleLink());
        } else {
          dispatch(setProgress(progressKey, 20 + (initedActionCount * progressStep)));
        }
      }, () => {
        initedActionCount += 1;
      });
    });
  };
}

export function toggleOnboardingProcess({ enable } = {}) {
  return {
    type: TOGGLE_ONBOARDINGPROCESS_STATUS,
    enable,
  };
}

export function resetMessage() {
  return {
    type: RESET_MESSAGE,
  };
}

export function setMessage(title, content, onConfirm, onCancel) {
  return {
    type: SET_MESSAGE,
    title,
    content,
    onConfirm,
    onCancel,
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/reducers/applicationReducer.js
 **/